/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderNewCalcSelectGetCalcOptionsQueryVariables = {||};
export type PGAModelBuilderNewCalcSelectGetCalcOptionsQueryResponse = {|
  +pgaModelCalcClassifications: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
  |}>
|};
export type PGAModelBuilderNewCalcSelectGetCalcOptionsQuery = {|
  variables: PGAModelBuilderNewCalcSelectGetCalcOptionsQueryVariables,
  response: PGAModelBuilderNewCalcSelectGetCalcOptionsQueryResponse,
|};
*/


/*
query PGAModelBuilderNewCalcSelectGetCalcOptionsQuery {
  pgaModelCalcClassifications {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PGATourModelCalcClassificationType",
    "kind": "LinkedField",
    "name": "pgaModelCalcClassifications",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderNewCalcSelectGetCalcOptionsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PGAModelBuilderNewCalcSelectGetCalcOptionsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7e1b312ee4113a4d59fe8bfbb21495c8",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderNewCalcSelectGetCalcOptionsQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderNewCalcSelectGetCalcOptionsQuery {\n  pgaModelCalcClassifications {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9347e141298346463a1f581805ff84b6';

module.exports = node;
